import { useContext } from "react";
import { Alert } from "@mui/material";
import { FirmaElectronicaContext } from "../context/firmaElectronicaContext";

export const ErrorMessage = () => {
  const { errorMessage } = useContext(FirmaElectronicaContext);

  return (
    <>
      {!errorMessage.length
        ? null
        : errorMessage.map((error) => (
            <Alert key={error} severity="error">
              {error}
            </Alert>
          ))}
    </>
  );
};
